import { msg } from 'gt-react';
import { DatabaseIcon } from '@phosphor-icons/react';
import { Action, Subject } from '@erp/authz';
import { ProductModule } from '@erp/shared-types';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import {
  Route as pathlessAuthenticatedRoute,
  requireModules,
  requireAdmin,
} from '../../route';

const AS400RawDataPage = lazyRouteComponent(
  () => import('./AS400RawDataPage'),
  'AS400RawDataPage',
);

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/procurement/as400-raw-data',
  staticData: {
    app: {
      nav: {
        label: msg('AS400 Raw Data', {
          context: 'sidebar nav label, Procurement section',
        }),
        icon: <DatabaseIcon className="h-4 w-4" weight="fill" />,
        group: 'Procurement',
        order: 35,
        groupOrder: 30,
      },
      access: {
        adminOnly: true,
        modulesAnyOf: [ProductModule.PROCUREMENT],
        permissionsAnyOf: [{ action: Action.Read, subject: Subject.Inventory }],
      },
    },
  },
  component: AS400RawDataPage,
  loader: () => ({
    crumb: msg('AS400 Raw Data', { context: 'page breadcrumb' }),
  }),
  beforeLoad: ({ context }) => {
    requireAdmin({ context });
    requireModules({
      context,
      oneOf: [ProductModule.PROCUREMENT],
    });
  },
});
